// ==========================================================================
// components/Sprig.tsx — a leafy sprig in the family tree's hand (FF-057).
// Used on the journal cover and the calendar. Colours from the --tree-* tokens.
// ==========================================================================
export default function Sprig({ className = "", flip = false }: { className?: string; flip?: boolean }) {
  const leaf = "M0,0 C6,-12 21,-13 29,-1 C21,11 7,12 0,0 Z";
  return <svg viewBox="0 0 120 120" className={className} aria-hidden style={flip ? { transform: "scaleX(-1)" } : undefined}>
    <path d="M10,112 C30,80 52,52 104,14" stroke="rgb(var(--tree-bark) / 0.6)" strokeWidth="2.2" fill="none" />
    {[[24, 92, -60], [34, 78, 20], [46, 64, -50], [58, 52, 30], [70, 42, -40], [82, 32, 25], [94, 22, -30]].map(([x, y, r], i) =>
      <path key={i} d={leaf} transform={`translate(${x} ${y}) rotate(${r}) scale(${0.7 + (i % 3) * 0.12})`} fill={`rgb(var(${i % 2 ? "--tree-leaf-light" : "--tree-leaf"}) / 0.85)`} />)}
  </svg>;
}
